module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text/7-b185b15827a8f8588157d7197ce04edb.jpg";